<template>
  <v-layout
    wrap
    white-label-design-dark
    style="margin: 0"
  >
    <helper-cropper
      ref="cropper"
      :aspect-ratio="250 / 100"
      :width="250"
      :height="100"
      @updateAvatar="updateAvatar"
    />
    <v-flex
      mt-4
      md12
      xs12
    >
      <div
        class="logo"
        :class="light_theme_logo ? 'no-border': 'fill-height justify-center align-content-center'"
        @click.stop="$refs.image.click()"
      >
        <div v-if="!light_theme_logo">
          <v-icon>mdi-cloud-upload</v-icon>
          <p>{{ $t('projects.upload') }}</p>
          <p>PNG / JPG</p>
          <small>250x100px</small>
        </div>
        <div style="width:250px;overflow:hidden;">
          <figure v-if="light_theme_logo">
            <figcaption>
              {{ $t('whitelabel.captionLogoImage') }}
            </figcaption>
            <img
              :src="light_theme_logo"
              width="250"
            >
          </figure>
        </div>
        <input
          ref="image"
          type="file"
          style="display: none"
          accept="image/*"
          @change="setImage"
        >
      </div>
    </v-flex>
    <!-- Removed before approve-->
    <v-flex
      v-if="false"
      mt-4
      md6
      xs12
    >
      <div
        class="logo"
        :class="light_theme_background_image ? 'no-border': 'fill-height justify-center align-content-center'"
        @click.stop="$refs.backgroundImage.click()"
      >
        <div v-if="!light_theme_background_image">
          <v-icon>mdi-cloud-upload</v-icon>
          <p>{{ $t('whitelabel.uploadBackgroundImage') }}</p>
          <p>PNG / JPG</p>
        </div>
        <div style="width:250px;overflow:hidden;">
          <figure v-if="light_theme_background_image">
            <figcaption>
              {{ $t('whitelabel.captionBackgroundImage') }}
            </figcaption>
            <img
              :src="light_theme_background_image"
              width="250"
            >
          </figure>
        </div>
        <input
          ref="backgroundImage"
          type="file"
          style="display: none"
          accept="image/*"
          @change="setBackgroundImage"
        >
      </div>
    </v-flex>
    <v-flex
      v-for="(c,i) in supported_colors"
      :key="i"
      mt-4
      xs6
      md4
      supported_colors
    >
      <div
        :id="c.id"
        class="selected-color"
        :style="'background-color:'+ getDefaultColor(c.id)"
        @click="openColorDialog"
      />
      <small :style="$vuetify.breakpoint.xs ? 'clear:both;' : ''">{{ c.text }}</small>
    </v-flex>
    <chrome-picker
      v-if="colorDialog"
      v-on-clickaway="hideColorDialog"
      :value="colors"
      @input="updateColor"
    />
    <v-flex
      xs12
    >
      <div
        class="mockup"
        :style="`background-image: url('${light_theme_background_image}')`"
      >
        <div
          class="mockup-drawer"
          :style="'background-color:'+ convertRGBAtoString(light_theme_primary_color.rgba)"
        >
          <div
            class="mockup-logo"
            :style="$vuetify.breakpoint.xs ? 'width:80px' : 'width:160px'"
          >
            <img
              :src="(light_theme_logo || $ls.get('config').logo_light_theme)"
              :width="$vuetify.breakpoint.xs ? '80' : '100'"
            >
          </div>
          <div
            v-if="!$vuetify.breakpoint.xs"
            class="mockup-menu apply-font"
            :style="mockupTextStyle"
          >
            <span>{{ $t('whitelabel.mockupDashboard') }}</span>
            <span>{{ $t('drawer.users') }}</span>
            <span>{{ $t('drawer.withdrawals') }}</span>
            <span>{{ $t('whitelabel.mockupBilling') }}</span>
          </div>
        </div>
        <div
          class="mockup-toolbar"
          :style="'background-color:'+ convertRGBAtoString(light_theme_secondary_color.rgba)"
        >
          <div
            class="mockup-button"
            :style="'background-color:'+ convertRGBAtoString(light_theme_primary_color.rgba)"
          >
            <span
              :style="mockupTextStyle"
            >{{ $t('whitelabel.button') }}
            </span>
          </div>
        </div>
        <div
          class="mockup-card"
          :style="'background-color:'+ convertRGBAtoString(light_theme_secondary_color.rgba)"
        >
          <span
            :style="mockupSecondaryTextStyle"
          >
            <b>{{ $t('whitelabel.mockupDashboard') }}</b><br>
            <small>
              {{ $t('whitelabel.mockupText') }}
            </small>
          </span>
        </div>
      </div>
    </v-flex>
    <pre />
  </v-layout>
</template>

<script>

import { directive as onClickaway } from "vue-clickaway";
import { Chrome } from "vue-color";

export default {
  name: "WhiteLabelDesignLignt",
  directives: {
    onClickaway
  },
  components: {
    "chrome-picker": Chrome,
  },
  props: {
    editForm: {
      type: Object,
      default: null
    },
    fontFamily: {
      type: String,
      default: 'Open Sans'
    }
  },
  data() {
    return {
      supported_colors: [
        {id: "light_theme_primary_color", text: this.$t('whitelabel.primaryColor')},
        {id: "light_theme_secondary_color", text: this.$t('whitelabel.secondaryColor')},
        {id: "light_theme_primary_text_color", text: this.$t('whitelabel.primaryColorText')},
      ],
      dialog: false,
      colorDialog: false,
      current_color_selection: null,
      imageName: "",
      imageFile: "",
      valid: false,
      light_theme_logo: null,
      light_theme_background_image: null,
      colors: {
        rgba: { r: 255, g: 255, b: 255, a: 1 },
      },
      light_theme_background_color: {
        rgba: { r: 247, g: 248, b: 249, a: 1 },
      },
      light_theme_primary_color: {
        rgba: { r: 63, g: 6, b: 73, a: 1 },
      },
      light_theme_primary_text_color: {
        rgba: { r: 255, g: 255, b: 255, a: 1 },
      },
      light_theme_secondary_color: {
        rgba: { r: 255, g: 255, b: 255, a: 1 },
      },
    };
  },
  computed: {
    mockupTextStyle() {
      return {
        color: this.convertRGBAtoString(this.light_theme_primary_text_color.rgba),
        fontFamily: this.fontFamily
      }
    },
    mockupSecondaryTextStyle() {
      return {
        color: "#000000",
        fontFamily: this.fontFamily
      }
    },
  },
  watch: {
    editForm(value) {
      if (value && value.design) {
        this.light_theme_logo = value.design.light_theme_logo
        // this.light_theme_background_image = value.design.light_theme_background_image;
        this.light_theme_primary_color.rgba = this.convertStringToRGBA(value.design.light_theme_primary_color);
        this.light_theme_primary_text_color.rgba = this.convertStringToRGBA(value.design.light_theme_primary_text_color);
        this.light_theme_secondary_color.rgba = this.convertStringToRGBA(value.design.light_theme_secondary_color);
      }
    }
  },
  methods: {
    save() {
      let form =  {
        light_theme_logo: this.light_theme_logo,
        // light_theme_background_image: this.light_theme_background_image,
        light_theme_primary_color: this.convertRGBAtoString(this.light_theme_primary_color.rgba),
        light_theme_primary_text_color: this.convertRGBAtoString(this.light_theme_primary_text_color.rgba),
        light_theme_secondary_color: this.convertRGBAtoString(this.light_theme_secondary_color.rgba)
      }
      this.$emit('saveThemes', form, 'light');
    },
    setImage(e) {
      if (!this.$refs.cropper.setImage(e)) {
        this.$refs.image.value = "";
      }
    },
    async setBackgroundImage(e) {
      const file = e.srcElement.files[0];
      const base64 = await this.convertBase64(file);
      this.light_theme_background_image = base64;
    },
    convertBase64(file){
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    },
    updateAvatar(avatar) {
      this.light_theme_logo = avatar;
    },
    updateColor(color) {
      this[this.current_color_selection] = color
    },
    getDefaultColor(id) {
      return this.convertRGBAtoString(this[id].rgba);
    },
    openColorDialog(e) {
      this.colors.rgba = this[e.target.id].rgba
      this.current_color_selection = e.target.id
      this.colorDialog = true
    },
    hideColorDialog(e) {
      if (e) e.preventDefault();
      if (this.colorDialog && e.target.className !== "selected-color") {
        this.colorDialog = false;
      }
    },
    convertRGBAtoString(val) {
      if(val.hasOwnProperty('r') &&
          val.hasOwnProperty('g') &&
          val.hasOwnProperty('b') &&
          val.hasOwnProperty('a')){

            return `rgba(${val.r},${val.g},${val.b},${val.a})`;
      }
      return val;
    },
    convertStringToRGBA(val) {
      const rgbaRegex = /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/;
      const match = val.match(rgbaRegex);
      if (match) {
        const [, red, green, blue, alpha] = match;
        return {
          r: parseInt(red),
          g: parseInt(green),
          b: parseInt(blue),
          a: parseFloat(alpha)
        }
      }
      return val;
    }
  }
};
</script>

<style lang="scss" scoped>
  figcaption {
    small {
      font-size: 80% !important;
    }
  }
</style>
